import { Navigate } from "react-router-dom";
import { useIsLoggedIn } from "@dynamic-labs/sdk-react-core";

import { Paths } from "../common/constants";

const PublicRoute = ({ children }: any) => {
  const isLoggedIn = useIsLoggedIn();

  if (isLoggedIn) {
    return <Navigate to={Paths.MY_LIBRARY} replace />;
  }

  return children;
};

export default PublicRoute;
